import { render, staticRenderFns } from "./BuscadorFicha.vue?vue&type=template&id=4a9f111d&"
import script from "./BuscadorFicha.vue?vue&type=script&lang=js&"
export * from "./BuscadorFicha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports